import type * as React from 'react';

/** One ref for an input that both a caller and the component itself need to hold. */
export function mergeInputRefs(
  callerRef: React.Ref<HTMLInputElement> | undefined,
  ownRef: (input: HTMLInputElement | null) => void,
): (input: HTMLInputElement | null) => void {
  return (input) => {
    ownRef(input);
    if (typeof callerRef === 'function') callerRef(input);
    else if (callerRef) callerRef.current = input;
  };
}
